import { selfPacedCourses } from './coursesData/selfPaced';
import { liveCourses } from './coursesData/live';
import { buildFoundations } from './coursesData/foundations';
import { offlineClasses } from './coursesData/offline';
import { freeCourses } from './coursesData/free';
import { dacCourses } from './coursesData/dac';
import { aimlCourses } from './coursesData/aiml';

export const allCourses = {
  'dac': dacCourses,
  'self-paced': selfPacedCourses,
  'live': liveCourses,
  'offline': offlineClasses,
  'free': freeCourses,
  'foundations': buildFoundations,
  'aiml': aimlCourses,
}; 